var _defs, _path, _path2, _path3, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Smoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "KsnfAXHA5MqlWIniFO1DCa",
    x1: 21.101,
    x2: 31.275,
    y1: 24.636,
    y2: 62.397,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 2",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e36001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "KsnfAXHA5MqlWIniFO1DCb",
    x1: 23.281,
    x2: 28.27,
    y1: 32.438,
    y2: 53.373,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 129",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#889097",
    d: "M41.15747,24.69373A6.49466,6.49466,0,0,0,35.5,15a6.57483,6.57483,0,0,0-.68481.03668,10.9902,10.9902,0,0,0-21.63038,0A6.57483,6.57483,0,0,0,12.5,15a6.49466,6.49466,0,0,0-5.65747,9.69373A9.61625,9.61625,0,0,0,12.625,42c.0415,0,.08167-.00568.123-.00623L12.75,42H35.375a9.61625,9.61625,0,0,0,5.78247-17.30627Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M35.635,31.11859A5.49418,5.49418,0,0,0,31.5,22a5.54765,5.54765,0,0,0-.58435.03174,7.0002,7.0002,0,1,0-13.8313,0A5.49459,5.49459,0,0,0,11,27.5a5.473,5.473,0,0,0,1.36505,3.61859A5.49988,5.49988,0,0,0,13.5,42h21a5.49988,5.49988,0,0,0,1.135-10.88141Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#KsnfAXHA5MqlWIniFO1DCa)",
    d: "M20,42l-5.73039-4.09313A.5.5,0,0,1,14.56023,37H20l-3.12846-7.039a.5.5,0,0,1,.777-.58718L22,33V22.5a.5.5,0,0,1,.96154-.19231L27,32l3.59766-3.59766a.5.5,0,0,1,.83247.49722L29,37l5.30023-.75718a.5.5,0,0,1,.3961.87461L29,42Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#KsnfAXHA5MqlWIniFO1DCb)",
    points: "22 42 20.975 41 23 41 21 36 24 39 24 31 25.5 38 28 34 26 41 28 41 26.941 42 22 42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Smoke);
export default __webpack_public_path__ + "static/media/icons8-smoke.34268a441176ae2a69a82666d08d34a2.svg";
export { ForwardRef as ReactComponent };